import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Frontend route guard. Backend auth remains the source of truth.
 * Unauthorized users are redirected (default: /dashboard).
 */
export default function RequireRole({ roles, children, redirectTo = '/dashboard' }) {
  const { user } = useAuth();

  if (!roles || roles.length === 0) {
    return children;
  }

  if (!user || !roles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
